// src/utils/academicsMenuData.js
export const academicsMegaMenuData = [
  {
    id: "ug-full",
    title: "Under Graduate Programmes",
    url: "/undergraduate",
    footerNav: [
      { id: "pedagogy", title: "Pedagogy", url: "/pedagogy" },
      { id: "Academic-back-of-credit", title: "Academic Bank of Credits", url: "/academic-bank-of-credits" },
      { id: "nep-comliance", title: "NEP Compliance", url: "/nep-compliance" },
      // { id: "annual-report", title: "Annual Report", url: "https://cdn.msu.edu.in/msu-pdf-files/Annual-Report-2024.pdf", target: "_blank" },
      { id: "faculty", title: "Our Faculty", url: "/our-faculty" },
      { id: "research-publications", title: "Research & Publications", url: "/research-and-development-cell" },
      // { id: "placement", title: "Placements", url: "/placement-cell-and-activities" },
      { id: "academic-calendar", title: "Academic Calendar", url: "/academic-calendar-2025-26", target: "_blank" },
      { id: "notice-board", title: "Notice Board", url: "/circulars-and-notices" }
    ],
    children: [
      {
        id: "health-science",
        title: "School of Health Science & Technology",
        url: "/school/school-of-health-science-and-technology",
        column: 1,
        children: [
          { id: "emergency-medical", title: "Bachelor of Emergency Medical Technologist (Paramedic)", url: "/course/bachelors-in-emergency-medical-technology" },
          { id: "dialysis-therapy", title: "Bachelor of Dialysis Therapy Technology", url: "/course/bachelors-in-dialysis-therapy-technology" },
          // { id: "medical-lab", title: "Bachelors. in Medical Laboratory Technology", url: "#" },
          { id: "medical-radiology", title: "Bachelor of Medical Radiology & Imaging Technology", url: "/course/b-sc-in-medical-radiology-and-imaging-technology" },
          { id: "anesthesia", title: "Bachelor of Anesthesia & Operation Theatre Technology", url: "/course/bachelors-in-anesthesia-and-operation-theatre-technology" },
          { id: "optometry", title: "Bachelor of Optometry", url: "/course/bachelors-in-optometry" },
          { id: "physiotherapy", title: "Bachelor of Physiotherapy", url: "/course/bachelors-in-physiotherapy" },
          { id: "hospital-admin", title: "Bachelor of Hospital Administration", url: "/course/bachelors-in-hospital-administration" },
          { id: "medical-laboratory-science", title: "Bachelor of Medical Laboratory Science", url: "/course/b-sc-in-medical-laboratory-technology" },
          { id: "nutrition-dietetics", title: "B.Sc. in Nutrition & Dietetics", url: "/course/b-sc-in-nutrition-and-dietetics" }
        ]
      },
      {
        id: "computer-science",
        title: "School of Computer Science & Engineering",
        url: "/school/school-of-computer-science-and-engineering",
        column: 2,
        children: [
          {
            id: "btech-cse",
            title: "B.Tech in Computer Science & Engineering",
            url: "#",
            children: [
              { id: "ai-ml", title: "Artificial Intelligence & Machine Learning", url: "/course/btech-in-artificial-intelligence-and-machine-learning" },
              { id: "cloud-computing", title: "Cloud Computing & Cyber Security", url: "/course/btech-in-cloud-computing-and-cyber-security" }
            ]
          },
          { id: "bca-fullstack", title: "BCA in Full-Stack Development & Cloud Integration", url: "/course/bca-in-full-stack-development" },
          { id: "bca-software", title: "BCA in Software Development", url: "/course/bca-in-software-development" }
        ]
      },
      {
        id: "hospitality",
        title: "School of Hospitality & Tourism",
        url: "/school/school-of-hospitality-and-tourism",
        column: 2,
        children: [
          { id: "bsc-hospitality", title: "B.Sc. in Hospitality & Hotel Management", url: "/course/b-sc-in-hospitality-and-hotel-management" }
        ]
      },
      {
        id: "pharmacy",
        title: "School of Pharmacy",
        url: "/school/school-of-pharmacy",
        column: 2,
        children: [
          { id: "bachelor-pharmacy", title: "Bachelor of Pharmacy", url: "/course/b-pharm-in-pharmacy" }
        ]
      },
      {
        id: "management-commerce",
        title: "School of Management & Commerce",
        url: "/school/school-of-management-and-commerce",
        column: 3,
        children: [
          { id: "bba", title: "BBA (Business Management)", url: "/course/bba-in-business-management" },
          { id: "bcom-accounting", title: "B.Com in Professional Accounting", url: "/course/b-com-in-professional-accounting" }
        ]
      },
      {
        id: "nursing",
        title: "College of Nursing",
        url: "/school/college-of-nursing",
        column: 3,
        children: [
          { id: "bsc-nursing", title: "B.Sc. in Nursing", url: "/course/b-sc-in-nursing" }
        ]
      },
      {
        id: "humanities",
        title: "School of Humanities",
        url: "/school/school-of-humanities",
        column: 3,
        children: [
          { id: "ba-english", title: "BA in Applied English", url: "/course/ba-in-applied-english" }
        ]
      },
      {
        title: "Explore all UG Programmes",
        url: "/undergraduate",
        row: 3,
        class: "explore-all",
        external: false
      },
      {
        title: "Explore Industry Co-led UG Programmes",
        url: "/industry-co-led-ug-programmes",
        row: 3,
        class: "explore-all-co-led",
        external: false
      }
    ]
  },

  {
    id: "pg-full",
    title: "Post Graduate Programmes",
    url: "/postgraduate",
    footerNav: [
      { id: "pedagogy", title: "Pedagogy", url: "/pedagogy" },
      { id: "Academic-back-of-credit", title: "Academic Bank of Credits", url: "/academic-bank-of-credits" },
      { id: "nep-comliance", title: "NEP Compliance", url: "/nep-compliance" },
      // { id: "annual-report", title: "Annual Report", url: "https://cdn.msu.edu.in/msu-pdf-files/Annual-Report-2024.pdf", target: "_blank" },
      { id: "faculty", title: "Our Faculty", url: "/our-faculty" },
      { id: "research-publications", title: "Research & Publications", url: "/research-and-development-cell" },
      // { id: "placement", title: "Placements", url: "/placement-cell-and-activities" },
      { id: "academic-calendar", title: "Academic Calendar", url: "/academic-calendar-2025-26", target: "_blank" },
      { id: "notice-board", title: "Notice Board", url: "/circulars-and-notices" }
    ],
    children: [
      {
        title: "School of Health Science & Technology",
        url: "/school/school-of-health-science-and-technology",
        column: 1,
        children: [
          { title: "Master of Advanced Care Paramedic", url: "/course/master-of-advanced-care-paramedic" },
          { title: "M.Sc. in Dialysis Therapy", url: "/course/m-sc-in-dialysis-therapy" },
          { title: "M.Sc. in Medical Laboratory Science", url: "/course/m-sc-in-medical-laboratory-technology" },
          { title: "M.Sc. in Medical Radiology & Imaging Technology", url: "/course/m-sc-in-medical-radiology-and-imaging-technology" },
          { title: "M.Sc. in Anesthesia & Operation Theatre Technology", url: "/course/master-s-in-anesthesia-and-operation-theatre-technology" },
          { title: "Master of Optometry", url: "/course/masters-in-optometry" },
          { title: "M.Sc. in Clinical Microbiology", url: "/course/m-sc-in-clinical-microbiology" },
        ]
      },
      {
        title: "School of Computer Science & Engineering",
        url: "/school/school-of-computer-science-and-engineering",
        column: 2,
        children: [
          { title: "MCA in Data Analytics", url: "/course/mca-in-data-analytics" },
          { title: "MCA in Cyber Security", url: "/course/mca-in-cyber-security" }
        ]
      },
      // {
      //   title: "School of Pharmacy",
      //   url: "/school/school-of-pharmacy",
      //   column: 2,
      //   children: [
      //     { title: "Masters in Pharmacy", url: "/course/d-pharm-in-pharmacy" }
      //   ]
      // },
      {
        title: "School of Management & Commerce",
        url: "/school/school-of-management-and-commerce",
        column: 3,
        children: [
          {
            title: "M.Com in Professional Accounting",
            url: "/course/m-com-in-professional-accounting"
          },
          {
            title: "MBA in",
            children: [
              { title: "Major: Strategic Marketing", url: "/course/mba-in-strategic-marketing" },
              { title: "Major: Business Finance", url: "/course/mba-in-business-finance" },
              { title: "Major: Tech HR", url: "/course/mba-in-tech-hr" },
              // { title: "Minor: Business Analytics", url: "/course/mba-in-business-analytics" }
            ]
          }
        ]
      },
      {
        title: "School of Humanities",
        url: "/school/school-of-humanities",
        column: 3,
        children: [
          { title: "MA in Applied English", url: "/course/ma-in-applied-english" }
        ]
      },
      {
        title: "Explore all Post Graduate Programmes",
        url: "/postgraduate",
        row: 3,
        class: "explore-all",
        external: false
      },
      {
        title: "Explore Industry Co-led PG Programmes",
        url: "/industry-co-led-pg-programmes",
        row: 3,
        class: "explore-all-co-led",
        external: false
      }
    ]
  },

  {
    id: "diploma-full",
    title: "Diploma Programmes",
    url: "/diploma",
    footerNav: [
      { id: "pedagogy", title: "Pedagogy", url: "/pedagogy" },
      { id: "Academic-back-of-credit", title: "Academic Bank of Credits", url: "/academic-bank-of-credits" },
      { id: "nep-comliance", title: "NEP Compliance", url: "/nep-compliance" },
      // { id: "annual-report", title: "Annual Report", url: "https://cdn.msu.edu.in/msu-pdf-files/Annual-Report-2024.pdf", target: "_blank" },
      { id: "faculty", title: "Our Faculty", url: "/our-faculty" },
      { id: "research-publications", title: "Research & Publications", url: "/research-and-development-cell" },
      // { id: "placement", title: "Placements", url: "/placement-cell-and-activities" },
      { id: "academic-calendar", title: "Academic Calendar", url: "/academic-calendar-2025-26", target: "_blank" },
      { id: "notice-board", title: "Notice Board", url: "/circulars-and-notices" }
    ],
    children: [
      {
        title: "School of Computer Science & Engineering",
        url: "/school/school-of-computer-science-and-engineering",
        column: 1,
        children: [
          { title: "Diploma in Computer Science Engineering", url: "/course/diploma-in-computer-science-engineering" }
        ]
      },
      {
        title: "School of Pharmacy",
        url: "/school/school-of-pharmacy",
        column: 1,
        children: [
          { title: "Diploma in Pharmacy", url: "/course/d-pharm-in-pharmacy" }
        ]
      },
      {
        title: "School of Health Science & Technology",
        url: "/school/school-of-health-science-and-technology",
        column: 2,
        children: [
          { title: "Diploma in Emergency Medical Technology", url: "/course/diploma-in-emergency-medical-technology" },
          { title: "Diploma in Dialysis Therapy Technology", url: "/course/diploma-in-dialysis-therapy-technology" },
          { title: "Diploma in Medical Laboratory Science", url: "/course/diploma-in-medical-laboratory-technology" },
          { title: "Diploma in Medical Radiology & Imaging Technology", url: "/course/diploma-in-medical-radiology-and-imaging-technology" },
          { title: "Diploma in Anesthesia & Operation Theatre Technology", url: "/course/diploma-in-anesthesia-and-operation-theatre-technology" }
        ]
      },
      {
        title: "School of Hospitality & Tourism",
        url: "/school/school-of-hospitality-and-tourism",
        column: 3,
        children: [
          { title: "Professional Diploma in Hospitality & Hotel Management", url: "/course/professional-diploma-in-hospitality-and-hotel-management" }
        ]
      },
      {
        title: "Explore all Diploma Programmes",
        url: "/diploma",
        row: 3,
        class: "explore-all",
        external: false
      }
    ]
  },
  {
    id: "phd-programmes",
    title: "Ph.D. Programmes",
    url: "/course/doctor-of-philosophy-phd",
    footerNav: [
      { id: "pedagogy", title: "Pedagogy", url: "/pedagogy" },
      { id: "Academic-back-of-credit", title: "Academic Bank of Credits", url: "/academic-bank-of-credits" },
      { id: "nep-comliance", title: "NEP Compliance", url: "/nep-compliance" },
      // { id: "annual-report", title: "Annual Report", url: "https://cdn.msu.edu.in/msu-pdf-files/Annual-Report-2024.pdf", target: "_blank" },
      { id: "faculty", title: "Our Faculty", url: "/our-faculty" },
      { id: "research-publications", title: "Research & Publications", url: "/research-and-development-cell" },
      // { id: "placement", title: "Placements", url: "/placement-cell-and-activities" },
      { id: "academic-calendar", title: "Academic Calendar", url: "/academic-calendar-2025-26", target: "_blank" },
      { id: "notice-board", title: "Notice Board", url: "/circulars-and-notices" }
    ],
    children: [
      {
        title: "School of Doctoral Studies",
        url: "#",
        column: 1,
        children: [
          { title: "Allied Health Sciences", url: "/course/doctor-of-philosophy-phd", jslink: true },
          { title: "Pharmaceutical Sciences", url: "/course/doctor-of-philosophy-phd", jslink: true },
          { title: "Engineering Science & Technology", url: "/course/doctor-of-philosophy-phd", jslink: true },
          { title: "Management", url: "/course/doctor-of-philosophy-phd", jslink: true },
          { title: "Humanities", url: "/course/doctor-of-philosophy-phd", jslink: true },
          { title: "Hospitality and Tourism", url: "/course/doctor-of-philosophy-phd", jslink: true }
        ]
      },

    ]
  },

  // {
  //   id: "industry-full",
  //   title: "Industry Co-Led Programmes",
  //   url: "#",
  //   children: [
  //     // TOP ROW (row: 1)
  //     {
  //       title: "Programmes",
  //       class: "hide-title",
  //       column: 1,
  //       row: 1,
  //       children: [
  //         { title: "Bachelor of Business Administration", url: "#" },
  //         { title: "Bachelor of Vocation", url: "#" },
  //         { title: "Diploma of Vocation", url: "#" },
  //         { title: "Master of Business Administration", url: "#" },
  //         { title: "Postgraduate Diploma", url: "#" }
  //       ]
  //     },
  //     {
  //       title: "Programmes",
  //       class: "hide-title",
  //       column: 2,
  //       row: 1,
  //       children: [
  //         { title: "Diploma", url: "#" },
  //         { title: "4 Year Integrated B.Tech", url: "#" },
  //         { title: "Bachelors in Computer Application", url: "#" },
  //         { title: "Master of Vocation", url: "#" },
  //         { title: "Bachelor of Science", url: "#" }
  //       ]
  //     },
  //     {
  //       title: "Programmes",
  //       class: "hide-title",
  //       column: 3,
  //       row: 1,
  //       children: [
  //         { title: "Bachelor of Design", url: "#" },
  //         { title: "Bachelor of Arts", url: "#" },
  //         { title: "IIT/CTS", url: "#" },
  //         { title: "Bachelor of Visual Arts", url: "#" }
  //       ]
  //     },

  //     // SECOND ROW (row: 2)
  //     {
  //       title: "Hospitality & Hotel Management",
  //       column: 1,
  //       row: 2,
  //       children: [
  //         { title: "Bachelors. in Hospitality & Hotel Management", url: "#" },
  //         { title: "D.Voc in Hospitality & Hotel Operations", url: "#" },
  //         { title: "Professional Diploma in Hospitality", url: "#" }
  //       ]
  //     },
  //     {
  //       title: "Logistics",
  //       column: 2,
  //       row: 2,
  //       children: [
  //         { title: "Bachelors. in Logistics", url: "#" },
  //         { title: "D.Voc in Logistics & Operations", url: "#" },
  //         { title: "Professional Diploma in Logistics", url: "#" }
  //       ]
  //     },
  //     {
  //       title: "BFSI",
  //       column: 3,
  //       row: 2,
  //       children: [
  //         { title: "Bachelors. in BFSI", url: "#" },
  //         { title: "D.Voc in BFSI", url: "#" },
  //         { title: "Professional Diploma in BFSI", url: "#" }
  //       ]
  //     },

  //     // CTA ROW (row: 3 / special)
  //     {
  //       title: "Explore all Industry Co-Led Programmes",
  //       url: "/industry-co-led-programs",
  //       row: 3,
  //       class: "explore-all",
  //       external: false
  //     }
  //   ]
  // },

  {
    id: "international-full",
    title: "International Mobility Programmes",
    url: "",
    children: [
      {
        id: "oia-card",
        type: "card",
        logo: "https://cdn.msu.edu.in/OIA_380b7be7ad.png",
        logoAlt: "OiA – Office of International Affairs",
        title: "International Education & Placement",
        description:
          "The Office of International Affairs (OiA) is firmly committed to advancing its mission of cultivating a more equitable and interconnected global community by providing international education and placement opportunities.",
        ctaUrl: "https://international.msu.edu.in/",
        ctaLabel: "Know More",
        sections: [
          {
            heading: "International Examinations",
            left: [
              { label: "TestAF", value: "", url: "https://international.msu.edu.in/testas" },
              { label: "TestDaF", value: "", url: "https://international.msu.edu.in/testdaf" },
              { label: "TORFL", value: "", url: "https://international.msu.edu.in/torfl" }
            ],
            right: [
              // { label: "dMAT", value: "", url: "#" },
              // { label: "PSI (ISACA, GitHub, Nutanix, etc.)", value: "", url: "#" },
              // { label: "IELTS UKVI & Life Skills", value: "", url: "#" }
            ]
          }
        ]
      },
      {
        id: "shine-card",
        type: "card",
        logo: "https://cdn.msu.edu.in/SHINE_LOGO_37d0dec90a.png",
        logoAlt: "SHINE – Skill Hub for International Employment",
        title: "Skill Hub for International Employment",
        description:
          "The Skill Hub for International Employment collaborates closely with youth seeking employment worldwide. Its primary objective is to address the global skills gap through specialised international programmes.",
        ctaUrl: "https://international.msu.edu.in/",
        ctaLabel: "Know More",
        sections: [
          {
            heading: "Our Programmes",
            left: [
              { label: "Germany Nursing", url: "https://international.msu.edu.in/course/germany-nursing" },

            ],
            // right: [{ label: "Germany Automotive", url: "#" }]
          }
        ]
      }
    ]
  },

  {
    id: "pg-working-full",
    title: "PG Programmes For Working Professionals",
    url: "",
    children: [
      {
        id: "pg-working-management",
        title: "Management Programmes",
        url: "",
        column: 1,
        children: [
          // { id: "accelerated-skill-mba-15m-1", title: "Accelerated Skill MBA (pro) - 15 Months", url: "https://crux.msu.edu.in/crux-mba/" },
          // { id: "work-integrated-mba-24m-1", title: "Work Integrated MBA (pro) - 24 Months", url: "https://crux.msu.edu.in/mba-work-integrated-2-years/" },
          { id: "accelerated-skill-mba-15m-2", title: "Accelerated Skill MBA - 15 Months", url: "https://crux.msu.edu.in/accelerated-work-integrated-mba/" },
          { id: "work-integrated-mba-24m-2", title: "Work Integrated MBA - 24 Months", url: "https://crux.msu.edu.in/accelerated-work-integrated-mba/" }
        ]
      },
      {
        id: "pg-working-psychology",
        title: "Psychology Programmes",
        column: 2,
        url: "",
        children: [
          { id: "ma-psychology", title: "MA in Psychology", url: "https://lp.msu.edu.in/crux/ma-in-psychology-lp" },
          // { id: "ma-child-psychology", title: "MA in Child Psychology", url: "https://lp.msu.edu.in/crux/work-integrated-ma-in-child-psychology" },
          { id: "pgd-guidance-counselling", title: "PG Diploma in Guidance and Counselling", url: "https://lp.msu.edu.in/crux/pg-diploma-in-guidance-and-counselling" }
        ]
      },
      {
        id: "health-science-and-technology-programmes",
        title: "Health Science & Technology Programmes",
        column: 3,
        url: "",
        children: [
          {
            id: "master-of-hospitality-administration",
            title: "Master of Hospitality Administration",
            url: "https://lp.msu.edu.in/crux/master-of-hospitality-administration"
          },
          // {
          //   id: "msc-in-radiology-and-imaging-technology",
          //   title: "M.Sc in Radiology and Imaging Technology",
          //   url: "https://lp.msu.edu.in/crux/msc-in-radiology-and-imaging-technology"
          // },
          // {
          //   id: "msc-in-medical-laboratory-technology",
          //   title: "M.Sc in Medical Laboratory Technology",
          //   url: "https://lp.msu.edu.in/crux/msc-in-medical-laboratory-technology"
          // },
        ]
      },
      {
        id: "LXD-and-education-technology-programmes",
        title: "LXD & Education Technology Programmes",
        column: 3,
        url: "",
        children: [
          {
            id: "msc-in-radiology-and-imaging-technology",
            title: "M.Sc in Learning Experience Design and Education Technology",
            url: "https://lp.msu.edu.in/crux/work-integrated-msc-in-learning-experience-design-and-edtech"
          },
        ]
      },
      // {
      //   title: "Explore all PG Programmes for Working Professionals",
      //   url: "https://crux.msu.edu.in/",
      //   row: 3,
      //   class: "explore-all",
      //   external: false
      // }
    ]
  }
];
